import { z } from "zod";
/**
 * The ONLY variables allowed to reach the browser bundle.
 *
 * Vite imports this list and injects exactly these keys — see
 * apps/web-frontend/vite.config.ts. Adding a key here makes it public
 * forever: it is inlined as plaintext into JS that anyone can download.
 * Never add a secret.
 */
export const CLIENT_ENV_KEYS = [
    "SUPABASE_URL",
    "SUPABASE_PUBLISHABLE_KEY",
    "API_URL",
    "ACCESS_REQUEST_URL",
];
/**
 * Variables that must NEVER be inlined into client code. The build asserts
 * that none of these values appear in the bundle.
 */
export const SERVER_ONLY_ENV_KEYS = [
    "SUPABASE_SECRET_KEY",
    "DATABASE_URL",
    "SMTP_URL",
    "SIGNUP_CODE_PEPPER",
    "VIEWING_ROOM_PEPPER",
    "AUTH0_M2M_CLIENT_ID",
    "AUTH0_M2M_CLIENT_SECRET",
    "STREAM_API_SECRET",
    "ANTHROPIC_API_KEY",
    // Authorises starting, signalling and terminating every workflow in the
    // namespace — which for ONDO means undoing sales. On the list for the reason
    // STREAM_API_SECRET is.
    "TEMPORAL_API_KEY",
];
export const clientEnvSchema = z.object({
    /** Supabase project URL, e.g. https://abcdefgh.supabase.co */
    SUPABASE_URL: z.url(),
    /**
     * Publishable (anon) key. Safe to ship to browsers — it carries no
     * privileges of its own and every request it makes is still subject to
     * Row Level Security.
     */
    SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
    /**
     * Origin of the ondo API, e.g. https://api.ondo.example. Public — it is the
     * address the browser calls, not a credential.
     *
     * The preprocess is load-bearing: Vite's `define` writes
     * `rootEnv[key] || ""`, so an unset variable arrives here as an empty
     * string. That is present-and-invalid rather than absent, which a bare
     * `.default()` would not rescue.
     */
    API_URL: z.preprocess((value) => typeof value === "string" && value.trim() === "" ? undefined : value, z.url().default("http://localhost:3000")),
    /**
     * Where "Apply for access" sends someone who lacks a workspace.
     *
     * Configuration rather than a hardcoded link so it can move from a mailbox
     * to a form (Typeform or similar) without a code change. `z.url()` accepts
     * mailto:, so both work.
     */
    ACCESS_REQUEST_URL: z.preprocess((value) => typeof value === "string" && value.trim() === "" ? undefined : value, z.url().default("mailto:access@ondo.art")),
});
/**
 * Validates the client-visible env. Isomorphic — no filesystem access, so it
 * is safe to call from browser code with `import.meta.env`.
 */
export function parseClientEnv(source) {
    const result = clientEnvSchema.safeParse(source);
    if (!result.success) {
        throw new Error(`Invalid client environment:\n${formatIssues(result.error)}\n\n` +
            `Set these in the root .env — see .env.example.`);
    }
    return result.data;
}
export function formatIssues(error) {
    return error.issues
        .map((issue) => `  - ${issue.path.join(".") || "(root)"}: ${issue.message}`)
        .join("\n");
}
//# sourceMappingURL=client.js.map